import { TaskGroup } from '@dispatch/shared/types';

export const rows: TaskGroup[] = [
  {
    id: '949e809b-e574-4215-a67c-b563513ee29d',
    tenantId: '0001',
    name: 'North',
    description: 'States in the North',
    createdDate: new Date(Date.parse('2022-01-01T12:30:00.000Z')),
    createdBy: 'Stephen Strickland',
    lastEditedDate: new Date(Date.parse('2022-03-12T14:33:23.000Z')),
    lastEditedBy: 'Bob Villa',
    accessList: [],
    dispatchMethod: 'Optimized',
    dispatchConfigurations: [],
    userIds: [],
    deactivatedAt: null,
  },
  {
    id: '7eda817f-ba5f-40ed-97e1-4cb72cc83356',
    tenantId: '0002',
    name: 'South',
    description: 'States in the South',
    createdDate: new Date(Date.parse('2022-03-22T10:15:00.000Z')),
    createdBy: 'Bob Villa',
    lastEditedDate: new Date(Date.parse('2022-03-29T09:22:00.000Z')),
    lastEditedBy: 'Sarah North',
    accessList: [],
    dispatchMethod: 'Optimized',
    dispatchConfigurations: [],
    userIds: [],
    deactivatedAt: null,
  },
  {
    id: 'f702d8ee-7b8f-4281-aa42-3ada367b463c',
    tenantId: '0003',
    name: 'East',
    description: 'States in the East',
    createdDate: new Date(Date.parse('2022-03-22T10:15:00.000Z')),
    createdBy: 'Bob Villa',
    lastEditedDate: new Date(Date.parse('2022-03-29T09:22:00.000Z')),
    lastEditedBy: 'James Barker',
    accessList: [],
    dispatchMethod: 'Optimized',
    dispatchConfigurations: [],
    userIds: [],
    deactivatedAt: null,
  },
  {
    id: '614590e1-4079-4fc2-b763-c179e05c411c',
    tenantId: '0004',
    name: 'West',
    description: 'States in the West',
    createdDate: new Date(Date.parse('2022-03-22T10:15:00.000Z')),
    createdBy: 'Bob Villa',
    lastEditedDate: new Date(Date.parse('2022-03-29T09:22:00.000Z')),
    lastEditedBy: 'Dave Luse',
    accessList: [],
    dispatchMethod: 'Optimized',
    dispatchConfigurations: [],
    userIds: [],
    deactivatedAt: null,
  },
  {
    id: 'a6ac78bc-b7c3-42f8-9d3a-cdd5785040c3',
    tenantId: '0006',
    name: 'Manual',
    description: 'Manual dispatch task group',
    createdDate: new Date(Date.parse('2022-02-14T10:15:00.000Z')),
    createdBy: 'Bob Villa',
    lastEditedDate: new Date(Date.parse('2022-03-25T09:11:00.000Z')),
    lastEditedBy: 'Dave Luse',
    accessList: [],
    dispatchMethod: 'Optimized',
    dispatchConfigurations: [],
    userIds: [],
    deactivatedAt: null,
  },
];
